export default __webpack_public_path__ + "static/media/pack-2.9723685f.png";